export default __webpack_public_path__ + "static/media/gallery_14.0d60f143.jpg";